import { getStreets, IStreet, TDataResponse } from '~/src/api/content/street';

const DELAY_MS = 700;

let timerId: ReturnType<typeof setTimeout>;

interface ISearchParams {
    term: string,
    withSatelliteFilter?: boolean,
}

export const getFilterStreets = async(searchParams: ISearchParams, providerId: number): Promise<IStreet[] | null> => {
    const fetchStreets: Promise<TDataResponse> = new Promise((resolve) => {
        if (timerId) {
            clearTimeout(timerId);
        }

        timerId = setTimeout(async() => {
            const response = await getStreets({ providerId, ...searchParams });
            resolve(response);
        }, DELAY_MS);
    });

    const resp = await fetchStreets;
    return resp.isSuccess ? resp.payload : [];
};
